export var dataHooks = {
  panelHeaderTitle: 'panel-header-title'
};